"use client";
import { jsxs as s, jsx as t } from "react/jsx-runtime";
import { useLanguage as w, useMatches as l, rem as a, Grid as o, Image as S, Icon as m, Group as d, Box as z, Paragraph as c, Divider as C, Heading as j, getLocaleText as D } from "@ingeniorforeningen/figurine-core";
import { S as p } from "../../../../ListItem.module-B89DN3XQ.js";
import '../../../../assets/ListItemWithImage.css';const W = "_root_1s9c2_2", k = "_content_1s9c2_52", F = "_image_1s9c2_66", T = "_heading_1s9c2_84", B = "_tag_1s9c2_104", G = "_overline_1s9c2_122", n = {
  root: W,
  content: k,
  image: F,
  heading: T,
  tag: B,
  overline: G
}, v = (g) => {
  const { date: x, description: f, header: _, size: e } = g, { tag: i, image: I } = g, { language: h } = w(), y = l({
    base: "short",
    sm: "long"
  }), L = l({
    base: 3,
    lg: 4
  }), N = l({
    base: "h4",
    sm: e === "large" ? "h2" : "h3"
  });
  let r = x, u = a("6px");
  e === "large" && (r = void 0, u = a("16px"));
  const b = () => {
    switch (i) {
      case "article":
        return D(h, "article");
      case "news":
        return h === "da" ? "Nyhed" : "News";
      case "podcast":
        return "Podcast";
      default:
        return "";
    }
  };
  return /* @__PURE__ */ s(o, { container: !0, spacing: 0, className: n.root, mod: { size: e }, children: [
    /* @__PURE__ */ t(o, { item: !0, className: n.image, mod: { size: e }, children: /* @__PURE__ */ t(
      S,
      {
        ...I,
        byline: void 0,
        caption: void 0,
        overlay: e === "large" ? "var(--figurine-gradients-black)" : void 0,
        sizes: "(max-width: 48em) 90vw, (min-width: 48em && max-width: 75em) 335px, 460px",
        children: i === "podcast" && /* @__PURE__ */ t(
          m,
          {
            name: "Headphones",
            color: "light",
            mt: a("12px"),
            ml: a("12px"),
            size: a("24px"),
            variant: "blur"
          }
        )
      }
    ) }),
    /* @__PURE__ */ t(
      o,
      {
        item: !0,
        alignItems: e === "large" ? "end" : void 0,
        justifyItems: e === "large" ? "left" : void 0,
        children: /* @__PURE__ */ s(
          d,
          {
            direction: "column",
            spacing: u,
            pos: "relative",
            mod: { size: e },
            className: n.content,
            children: [
              e !== "large" && /* @__PURE__ */ t(z, { className: p.withBottomShadow }),
              /* @__PURE__ */ s(d, { className: n.overline, children: [
                i && /* @__PURE__ */ t(
                  c,
                  {
                    text: b(),
                    scale: 0.875,
                    medium: !0,
                    condensed: !0,
                    transform: "uppercase",
                    pos: "relative",
                    variant: e === "large" ? "light" : void 0,
                    className: n.tag,
                    mod: { tag: i, size: e }
                  }
                ),
                i && r && /* @__PURE__ */ t(C, { orientation: "vertical", color: "dark", size: "sm", pos: "relative" }),
                r && /* @__PURE__ */ t(
                  c,
                  {
                    text: `${r?.toLocaleString("da-DK", {
                      year: "numeric",
                      month: y,
                      day: "numeric"
                    })}`,
                    scale: 0.875,
                    condensed: !0,
                    medium: !0,
                    transform: "uppercase",
                    pos: "relative",
                    variant: i ? "neutral" : "primary"
                  }
                )
              ] }),
              /* @__PURE__ */ t(
                j,
                {
                  text: _,
                  type: N,
                  pos: "relative",
                  lineClamp: e !== "large" ? 3 : void 0,
                  variant: e === "large" ? "light" : "dark",
                  className: n.heading,
                  mod: { size: e }
                }
              ),
              e === "medium" && /* @__PURE__ */ t(
                c,
                {
                  visibleFrom: "sm",
                  condensed: !0,
                  lineClamp: L,
                  pos: "relative",
                  text: f
                }
              ),
              e === "large" && /* @__PURE__ */ s(d, { align: "center", spacing: a("6px"), children: [
                /* @__PURE__ */ t(c, { text: "Læs mere", variant: "light" }),
                /* @__PURE__ */ t(m, { name: "ChevronRight", color: "light" })
              ] })
            ]
          }
        )
      }
    ),
    e !== "large" && /* @__PURE__ */ t(
      o,
      {
        item: !0,
        alignItems: "center",
        justifyItems: "center",
        className: p.chevron,
        mod: { size: e },
        spacing: 0,
        visibleFrom: "sm",
        children: /* @__PURE__ */ t(m, { name: "ChevronRight", size: a("24px"), ml: a("6px") })
      }
    )
  ] });
};
v.displayName = "ListItemWithImage";
const K = v;
export {
  v as _ListItemWithImage,
  K as default
};
